@if (showErrors()) {
  <div class="td-wb-form-accessibility-alert__container">
    <div>
      @for (key of displayedAccessibleErrors; track key) {
        <div [id]="key">
          <span [innerText]="getAccessibleError(key) + (accessibleErrors[key].messageKey | tdWbTranslate)"></span>
        </div>
      }
    </div>
  </div>
}
